export default __webpack_public_path__ + "static/media/new-ps-logo.cbdbd6bf.png";